import React, { useEffect, useState } from "react";
import "./gallery.css";

const images = [
  "https://i.imgur.com/FCk2lWF.jpeg",
  "https://i.imgur.com/x43m4jI.jpeg",
  "https://i.imgur.com/wTTwV59.jpeg",
  "https://i.imgur.com/y3n1Swq.jpeg",
];

const Gallery = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="gallery-container">
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          className={`gallery-image ${index === current ? "active" : ""}`}
          alt={`Slide ${index + 1}`}
          loading={index === 0 ? "eager" : "lazy"}
          fetchpriority={index === 0 ? "high" : "auto"}
        />
      ))}
    </div>
  );
};

export default Gallery;